var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpectedTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 4V7.33352M9.16675 4V7.33352",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.66602H11.6667C8.52397 5.66602 6.95262 5.66602 5.97631 6.64238C5 7.61875 5 9.19018 5 12.3331V13.9998C5 17.1427 5 18.7142 5.97631 19.6905C6.95262 20.6669 8.52397 20.6669 11.6667 20.6669H13.3333C16.476 20.6669 18.0474 20.6669 19.0237 19.6905C20 18.7142 20 17.1427 20 13.9998V12.3331C20 9.19018 20 7.61875 19.0237 6.64238C18.0474 5.66602 16.476 5.66602 13.3333 5.66602Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.668H20",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.0841C10 16.0841 11.25 16.5008 11.6667 17.7509C11.6667 17.7509 13.4804 14.4174 15.8333 13.584",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectedTicketIc);
export default __webpack_public_path__ + "static/media/expected_ticket_ic.e9ed54b04e2bb476bb336ff0aa694988.svg";
export { ForwardRef as ReactComponent };